import React from 'react';

type IProps = {
  children: React.ReactNode;
  className?: string;
};

const AuthContent: React.FC<IProps> = ({ children, className = '' }) => (
  <div className={`auth-content ${className}`}>{children}</div>
);

export default AuthContent;
